import arePreferencesValid from './validation/preferences';
const DEFAULT_PREFERENCES = {
    isSoundEnabled: false,
};
export default function parsePreferences(storedData, callback) {
    let parsed;
    try {
        parsed = storedData === null ? undefined : JSON.parse(storedData);
    }
    catch {
        parsed = undefined;
    }
    if (parsed && arePreferencesValid(parsed)) {
        return { isSoundEnabled: parsed.isSoundEnabled };
    }
    else {
        if (callback)
            callback(DEFAULT_PREFERENCES);
        return DEFAULT_PREFERENCES;
    }
}
